export const geoControl = {
    enabled: true,
    _description: 'Enables the geo control feature on bank card settings page',
};
